import React from 'react';
import { Checkbox } from '@homeexchange/design';
import i18n from '../../../../i18n';
export var Quality = function (_a) {
    var values = _a.values, onUpdate = _a.onUpdate;
    return (React.createElement("div", null,
        React.createElement(Checkbox, { name: "filters", value: 'home-verified', checked: values && values.includes('home-verified'), onChange: onUpdate, label: i18n.t('search:filter.checkbox.verifiedHomes') }),
        React.createElement(Checkbox, { name: "filters", value: 'response-rate-above-threshold', checked: values && values.includes('response-rate-above-threshold'), onChange: onUpdate, label: i18n.t('search:filter.checkbox.responseRate') })));
};
